import { browserCheck } from '@ta-interaktiv/browsercheck'
export const config: {
  center: [number, number]
  bounds: [[number, number], [number, number]]
  boundsMobile: [[number, number], [number, number]]
  zoom: number
  maxZoom: number
  minZoom: number

  style: string
  style_fr: string
  locales: { attribution: string }
} = {
  center: [8.19, 46.82],

  bounds: browserCheck.isMobile
    ? [
        [5, 44.5],
        [11, 48.5]
      ]
    : [
        [5, 45.7],
        [11.5, 47.9]
      ],

  zoom: browserCheck.isMobile ? 6.5 : 7.5,
  maxZoom: 17,
  minZoom: browserCheck.isMobile ? 6.5 : 7.5,
  style: require('./style/tamedia_hazard.json'),
  style_fr: require('./style/tamedia_hazard_fr.json'),
  locales: { attribution: '© Gefahrenkarten der jeweiligen Kantone' }
}
